import { Pipe, PipeTransform } from '@angular/core';
import { ISiteRequestDetails } from 'src/app/feature/site-rediness-matrix/models/request';

@Pipe({
  name: 'customlength'
})
export class CustomlengthPipe implements PipeTransform {

  transform(value: number, args: ISiteRequestDetails[]): any {
    if (value === 0 && args) {
      return args.length;
    }
    return args?.filter(item => item.requestStatusId === value)?.length;
  }

}
